<template>
    <article v-if="usersList.length > 0" id="DailyCalendar__wrapper" class="calender-height">
        <FullCalendar :updatedOptions="calendarOptions" />
    </article>
</template>

<script src="./DailyCalendarContent.ts"></script>
